module.exports = __webpack_public_path__ + "img/icon_fachliche.193d46f5.svg";